const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
  
const GetResidentailServiceInstall = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_ALLOCATION_INSTALL_LIST':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_ALLOCATION_INSTALL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default GetResidentailServiceInstall;